import { API, axiosInstance } from "lib";

export const getStoreList = (data = {}) => {
  return axiosInstance
    .post(API.GET_WORKSHOP_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const createStore = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_WORKSHOP, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const editStore = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_WORKSHOP, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deleteStore = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_WORKSHOP, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getPartCategoryList = (data = {}) => {
  return axiosInstance
    .post(API.GET_PART_CATEGORY_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const addPartCategory = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_PART_CATEGORY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const editPartCategory = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_PART_CATEGORY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deleteCategory = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_PART_CATEGORY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getMeasurementUnitList = (data = {}) => {
  return axiosInstance
    .post(API.GET_MEASUREMENT_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const addService = (data = {}) => {
  return axiosInstance
    .post(API.ADD_SERVICE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getGstTypeData = (data = {}) => {
  return axiosInstance
    .get(API.GET_GST_MASTER_LIST)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getServiceList = (data = {}) => {
  return axiosInstance
    .post(API.GET_SERVICE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};


export const getServiceVoucherList = (data = {}) => {
  return axiosInstance
    .post(API.GET_SERVICE_VOUCHER_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};




export const getManufacturerList = (data = {}) => {
  return axiosInstance
    .post(API.GET_MANUFACTURER_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const createManufacturer = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_MANUFACTURER, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const editManufacturer = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_MANUFACTURER, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deleteManufacturer = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_MANUFACTURER, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getItemsList = (data = {}) => {
  return axiosInstance
    .post(API.GET_ITEMS_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const createItems = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_ITEMS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const editItems = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_ITEMS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deleteItems = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_ITEMS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const addPurchaseBill = (data = {}) => {
  return axiosInstance
    .post(API.ADD_PURCHESE_BILL, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getLisOfPurchaseBill = (data = {}) => {
  return axiosInstance
    .post(API.GET_PURCHASE_BILL_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deletePurchaseBill = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_PURCHASE_BILL, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

// service remainder

export const getServiceRemainder = (data = {}) => {
  return axiosInstance
    .post(API.GET_SERVICE_REMAINDER_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const getServiceRemainderCounts = (data = {}) => {
  return axiosInstance
    .post(API.SERVICE_REMAINDER_COUNT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const createServiceRemainder = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_SERVICES_REM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const markRemainderService = (data = {}) => {
  return axiosInstance
    .post(API.MARK_SERVICES_REM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const deleteServiceRemainder = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_SERVICE_REMAINDER, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};

export const makePaymentServiceApi = (data = {}) => {
  return axiosInstance
    .post(API.MAKE_PAYMENT_SERVICE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};


